








import { defineComponent, onMounted, nextTick, onBeforeMount, ref, provide } from '@vue/composition-api'
import { useRootReflectiveInjector } from '@zhfe/vue2-di-plugin'

import { HybridBridgeService } from '@/services/hybrid-bridge.service'
import { UserService } from '@/services/user.service'
import { CustomerService } from '@/services/customer.service'
import { Store } from 'vuex'
import { appInjector } from './app-injector'
import { ToastService } from '@/services/toast.service'
import { LS_EVENT } from './utils/localStorage'

export default defineComponent({
  setup (_, context) {
    const injector = useRootReflectiveInjector([
      HybridBridgeService,
      UserService, {
        provide: Store,
        useValue: context.root.$store
      },
      {
        provide: ToastService,
        useValue: new ToastService((context.root as any).$toast)
      },
      CustomerService
    ])
    injector.parentInjector = appInjector
    const user = injector.get(UserService)
    const bridge = injector.get(HybridBridgeService)
    const isRouterAlive = ref(true)

    onBeforeMount(() => {
      bridge.clientDomLoaded()
    })

    onMounted(() => {
      if (user.isLogin) {
        // 登录态下首次打开页面通知客户端刷新用户状态
        bridge.paySuccess()
      }
      bridge.reportDeviceAdminOperate()
      window.addEventListener('storage', (e) => {
        if(e.key === LS_EVENT.REFRESH_PAGE){
          window.location.reload()
        }
      })
    })

    function reload () {
      isRouterAlive.value = false
      nextTick(() => {
        isRouterAlive.value = true
      })
    }
    provide('reload', reload)

    return {
      isRouterAlive,
      // 屏蔽右键
      blockRightButton () {
        return false
      }
    }
  }
})
